import { Breadcrumbs } from '@polarislabs/polaris-ui-components';
import React from 'react';
import { withRouter } from 'react-router-dom';

import { renderMask } from 'utils/display';
import { translate } from 'utils/translations';

const CartBreadcrumbs = ({ match }) => {
  const { accountNumber } = match.params;

  const routes = [
    { url: '/accounts', label: translate('accounts', 'Accounts') },
    { url: `/accounts/${accountNumber}/details`, label: renderMask(accountNumber) },
    { url: `/accounts/${accountNumber}/order`, label: translate('shipping.order', 'Order') },
    { label: translate('store.cart', 'Cart') },
  ];

  return <Breadcrumbs routes={routes} />;
};

export default withRouter(CartBreadcrumbs);
